import L from "leaflet";
import MarkerIcon from "../../assets/IconsMap/ic-marker.svg";

/**
 * Default marker icon shared by every Leaflet map of the app.
 *
 * The `ic-marker` asset is 60x68 with the pin tip at (31.25, 60), so the anchor
 * keeps that tip over the real coordinate once the icon is scaled down.
 *
 * Maps that need a meaningful icon (the employee location pin, for example) can
 * still pass their own icon and override this one.
 */
export const DEFAULT_MARKER_ICON = new L.Icon({
    iconUrl: MarkerIcon,
    iconSize: [40, 45],
    iconAnchor: [21, 40],
    popupAnchor: [0, -40],
    tooltipAnchor: [0, -40],
});
